module.exports = __webpack_public_path__ + "img/eshoy_gold_more.a94ae668.png";